import axios from "axios";
import request from "../utils/request";

export class OrderApi {

  static requestUserId = "45678";
  static OrderFromUrl = {
    // queryInboundOrderUrl: "http://localhost:7001/inboundOrder/queryInboundOrders",
    // queryWarehouseUrl: "http://localhost:7001/inboundOrder/queryWarehouse",
    // queryOrderStatusUrl: "http://localhost:7001/inboundOrder/queryOrderStatus",
    // downloadExcelTemplateUrl: "http://localhost:7001/inboundOrder/downloadExcelTemplate",
    // queryProcessNodes: "http://localhost:7001/inboundOrder/getPurchaseOrderProcessNodeList",
    // queryAegPurchaseDetailUrl: "http://localhost:7001/inboundOrder/queryPurchaseOrderTest",
    // queryPurchaseOrderItemsUrl: "http://localhost:7001/inboundOrder/queryPurchaseOrderItemsTest",
    // queryConsignOrderUrl: "http://localhost:7001/inboundOrder/queryConsignOrderTest",
    // queryLazadaProcessNodes: "http://localhost:7001/inboundOrder/queryOperateHistoryList",
    // queryLazadaPurchaseDetailUrl: "http://localhost:7001/inboundOrder/getServiceOrderDetail",
    //

    // queryFulfillmentOrderUrl: "http://localhost:7001/fulfillmentOrder/queryList",
    queryFulfillmentOrderUrl: "/fulfillmentOrder/queryList",
    queryFulfillmentOrderDetailsUrl: "/fulfillmentOrder/queryDetails",
    queryFulfillmentStatus: "/fulfillmentOrder/queryFulfillmentStatus",
    queryFulfillmentShippingType: "/fulfillmentOrder/queryFulfillmentShippingTypes",
    queryFulfillmentStatusSteps: "/fulfillmentOrder/queryFulfillmentStatusSteps",
    fulfillmentOrderStatusUpdate: "/fulfillmentOrder/fulfillmentOrderStatusUpdate",
    batchfillmentOrderStatusUpdate: "/fulfillmentOrder/batchFulfillmentOrderStatusUpdate",
    queryMerchant: "/fulfillmentOrder/queryMerchant",
    querySiteList: "/fulfillmentOrder/querySiteList",

    queryCbFulfillmentOrderUrl: "/cbFulfillmentOrder/queryList",
    queryShipmentProvider: "/fulfillmentOrder/queryShipmentProvider",
    queryPdfUrl: "/fulfillmentPrint/queryPdfUrl",
  }

  /**
   * 表格查询参数
   *
   */
  static orderFromRequest = {
    orderFulfillmentOrderId: '',
    trackingNumber: '',
    warehouseCode: '',
    orderStatus: '',
    merchantCode: '',
    tradeOrderStartTime: '',
    TradeOrderEndTime: '',
    orderReverseTradeOrderId: ''
  };

  /**
   * 表格标题
   *
   */
  // static tableColumn = [
  //   {
  //     title: this.$t('message.table.fulfillment.fulfillmentOrderId'),
  //     width: 150,
  //     dataIndex: 'orderFulfillmentOrderId',
  //     render: (text, row, index) => {
  //       console.log(text, row);
  //       if (text == 'null') {
  //         return '';
  //       }
  //     },
  //     fixed: 'left'
  //   },
  //   {
  //     title: '子履约单号',
  //     width: 150,
  //     dataIndex: 'fulfillmentOrderItemId',
  //     fixed: 'left'
  //   },
  //   {
  //     title: '订单号',
  //     width: 150,
  //     dataIndex: 'orderTradeOrderId',
  //     fixed: 'left'
  //   },
  //   {
  //     title: '子订单号',
  //     width: 150,
  //     dataIndex: 'tradeOrderItemId',
  //     fixed: 'left'
  //   },
  //   {
  //     title: '逆向订单号',
  //     width: 150,
  //     dataIndex: 'orderReverseTradeOrderId'
  //   },
  //   {
  //     title: '运单号',
  //     width: 150,
  //     dataIndex: 'trackingNumbers'
  //   },
  //   {
  //     title: '行业',
  //     width: 150,
  //     dataIndex: 'merchantCode'
  //   },
  //   {
  //     title: '订单状态',
  //     width: 150,
  //     dataIndex: 'orderStatusDesc'
  //   },
  //   {
  //     title: '订单状态码',
  //     width: 150,
  //     dataIndex: 'orderStatus'
  //   },
  //   {
  //     title: '配送类型',
  //     width: 150,
  //     dataIndex: 'orderShippingTypeDesc'
  //   },
  //   {
  //     title: '买家名称',
  //     width: 150,
  //     dataIndex: 'orderBuyerName'
  //   },
  //   {
  //     title: '卖家id',
  //     width: 150,
  //     dataIndex: 'sellerId'
  //   },
  //   {
  //     title: '卖家名称',
  //     width: 150,
  //     dataIndex: 'sellerName'
  //   },
  //   {
  //     title: '仓编码',
  //     width: 150,
  //     dataIndex: 'warehouseCode'
  //   },
  //   {
  //     title: '仓名称',
  //     width: 150,
  //     dataIndex: 'warehouseName'
  //   },
  //   {
  //     title: '站点',
  //     width: 150,
  //     dataIndex: 'orderSiteId'
  //   },
  //   {
  //     title: '订单创建时间',
  //     width: 150,
  //     dataIndex: 'tradeCreateTime'
  //   },
  //   {
  //     title: '操作',
  //     width: 150,
  //     scopedSlots: {customRender: 'action'},
  //     fixed: 'right'
  //   }
  // ];

  // static itemColumn = [
  //   {
  //     title: 'Item Id',
  //     width: 150,
  //     dataIndex: 'itemId',
  //     fixed: 'left'
  //   },
  //   {
  //     title: 'Sc Item Id',
  //     width: 150,
  //     dataIndex: 'scItemId'

  //   },
  //   {
  //     title: 'Item Name',
  //     width: 150,
  //     dataIndex: 'itemName'
  //   },
  //   {
  //     title: 'Item Quantity',
  //     width: 100,
  //     dataIndex: 'orderLineQty'
  //   },
  //   {
  //     title: 'Item Actual Paid Fee',
  //     width: 150,
  //     dataIndex: 'itemActualPaidAmount'
  //   },
  //   {
  //     title: 'Item Discount Fee',
  //     width: 150,
  //     dataIndex: 'itemDiscountAmount'
  //   },
  //   {
  //     title: 'Item Tax Actual Fee',
  //     width: 150,
  //     dataIndex: 'itemTaxActualFee'
  //   },
  //   {
  //     title: 'Item Shipping Actual Paid Fee',
  //     width: 150,
  //     dataIndex: 'itemShippingActualPaidAmount'
  //   },
  //   {
  //     title: 'Unit Price',
  //     width: 150,
  //     dataIndex: 'unitPrice',
  //     fixed: 'right'
  //   }
  // ];
}




// WEBPACK FOOTER //
// ./src/js/OrderApi.js